// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__rfkzG","success":"Notification_success__FC0Zf","error":"Notification_error__NE+0V","closeButton":"Notification_closeButton__Jjas-"};